import { render, staticRenderFns } from "./ShareholderSetting.vue?vue&type=template&id=0faa57e4&scoped=true"
import script from "./ShareholderSetting.vue?vue&type=script&lang=js"
export * from "./ShareholderSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa57e4",
  null
  
)

export default component.exports